export default __webpack_public_path__ + "static/media/IG.be0a7d14.svg";